module.exports = __webpack_public_path__ + "static/img/anhui.6a257a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/industry/anhui.png
// module id = 3ng4
// module chunks = 1